@import '~style-sheet-helpers/core.less';
@import '../../../../../constants/spacing.module.less';

.shopper {
  padding: @space-16;
  border-radius: 4px;
  border: 1px solid var(--grey-300);
  margin-bottom: @space-8;
  background-color: @white;
}

.shopper-head {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  h3 {
    margin: 0;
  }
}

.shopper-controls {
  display: flex;
  align-items: center;
}

.expand-icon {
  height: 20px;
  width: 20px;
  color: var(--grey-600);
  margin-left: 30px;
}

.info-icon {
  color: var(--grey-600);
  height: 18px;
  width: 18px;
  margin-left: 8px;
}

.shopper-details {
  display: flex;
  gap: @space-8;
  align-items: center;
  h3 {
    font-size: 16px;
    font-weight: 500;
  }
}

.available {
  margin-right: @space-8;
}
